export var version = "2.6.0-beta.8";
//# sourceMappingURL=version.js.map